import './adminDashboard.css'
import React, { useContext, useState, useEffect } from 'react'
import Paper from '@mui/material/Paper'
import Avatar from '@mui/material/Avatar'
import arrow from '../../img/arrow.png'
import ApplicationIcon from '../../img/applications_icon.png'
import { Link, Route } from 'react-router-dom'
import ApiIcon from '../../img/api.jpg'
import TrackIcon from '../../img/track_status.png'
import ManageDevIcon from '../../img/manage_dev.png'
import AssessmentIcon from '../../img/admin_support.png';
import { useMsal } from '@azure/msal-react'
import AssignmentIcon from '@mui/icons-material/Assignment';
import Box from '@mui/material/Box'
import FormInput from '../../component/Common/FormInput'
import Button from '../../component/Common/Button'
import { useHistory } from 'react-router-dom'
import BackButton from '../../component/Common/BackBtn'
import { Typography } from '@mui/material'
import Navbar from "../../component/HeaderData";
import Footer from "../../component/FooterData";
import './adminDashboard.css'
import LockIcon from '../../assets/images/lockIcon.png'
import AdminIcon from '../../assets/images/admin.svg'
import reports from '../../assets/images/reports.svg'
import uploadIcon from '../../img/material-icons/file_upload.svg'
import calendarIcon from '../../assets/images/calendar.svg'
import dashboardIcon from '../../img/usa-icons/report.svg'
import referenceIcon from '../../img/usa-icons/folder.svg'
import userManagementIcon from '../../img/manage_dev.png'
import PageSubTitle from '../../component/Common/PageSubTitle'
import { useReportInventoryService } from '../../services/ReportInventoryServices';
import Cookies from 'js-cookie';
import { useLooksUpData } from '../../../src/utils/getLookupTableData';
import Dropdown from "../../component/Common/Dropdown";
import { GlobalContext } from "../../GlobalContext";
import { useAccessControl } from '../../../src/utils/AccessControlContext';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom'
import { userDetailsControl } from '../../UserContext';
import { Success_Messages, Warning_Messages, Error_Messages } from '../../utils/statusConstantValues';
import axios from 'axios';
import { getB2CGroupUrl } from "../../utils/url-constant";
import { setDateInCST } from '../../utils/dateUtils';

export default function AdminDashboard() {
  const { instance, accounts, inProgress } = useMsal()
  const history = useHistory()
  const orgId = sessionStorage.getItem('orgId')
  const [isLoading, setIsLoading] = useState(false)
  const ReportInventoryService = useReportInventoryService();
  const userType = sessionStorage.getItem('signedInUserType');
  let [signedInUserGroupsList, setSignedInUserGroupsList] = useState<any>([]);
  const [selectedProfile, setSelectedGroup] = useState<string>(sessionStorage.getItem('selectedProfile') || '');
  const loggedInUserDetailsForAudit = JSON.parse(sessionStorage.getItem('loginUserDetails') || '{}');
  const { getUserGroupTableLookupData } = useLooksUpData();
  const [mcUserGroupsList, setMcUserGroupsList] = useState<any[]>([]);
  const { globalVariable, setGlobalVariable } = useContext(GlobalContext);
  const [userAccessErrorMessage, setUserAccessErrorMessage] = useState<string>('');
  const { checkAccess, setPermissionsFromApiResponse } = useAccessControl();
  let [mcUsersList, setMcUsersList] = useState<UserList[]>([]);
  const [loggedInUserDetails, setLoggedInUserDetails] = useState<any>(null);
  let nonStateUserId = sessionStorage.getItem('signedInUserId');
  const [b2cUserDetails, setB2cUserDetails] = useState({})
  const [b2cUserGroupsUpdate, setB2cUserGroupsUpdate] = useState([])
  const { setUserDetails, setB2cUserGroups, b2cUserGroups } = userDetailsControl();
  const [showBannerFlag, setShowBannerFlag] = useState(false)
  const [systemUnavailableFlag, setSystemUnavailableFlag] = useState(false)
  const [systemUnavailableBannerMessage, setSystemUnavailableBannerMessage] = useState<string>('');

  let envPrefix = process.env.REACT_APP_ENV_PREFIX || '';

  interface UserList {
    userDetailsSid: string;
    orgUnitCd: string;
    email: string;
    userFirstName: string;
    userMiddleName: string;
    userLastName: string;
    userEmail: string;
    accountTypeLkpcd: string;
    phoneNumber1: string;
  }

  const fetchOutageBannerDetails = async () => {
    try {
      const response = await ReportInventoryService.getOutageBannerApi();
      if (response && response.data) {
        setShowBannerFlag(response.data.showBanner);
        setSystemUnavailableFlag(response.data.systemUnavailable);
        setSystemUnavailableBannerMessage(response.data.bannerMessage);
      }
    } catch (error) {
      console.error('Error fetching outage banner details:', error);
    }
  };

  useEffect(() => {
    fetchOutageBannerDetails();
  }, []);

  const fetchOrganizationUnitsTableLookupData = async () => {
    try {
      const response = await getUserGroupTableLookupData();
      if (response) {
        const { data } = response;

        if (Array.isArray(data)) {
          const filterAndMapData = data.map((code: any) => ({
            userGroupCode: `${code.userGroupCode}`,
            userGroupName: code.userGroupName,
          }));

          setMcUserGroupsList(filterAndMapData);
        } else {
          console.error('Expected data to be an array, but got:', data);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  //get B2C code from url
  function useQuery() {
    const { search } = useLocation()
    return React.useMemo(() => new URLSearchParams(search), [search])
  }

  let query = useQuery()
  let b2bLoggedinUserCode = query.get('code')
  const loggedInUserIPDetails = JSON.parse(sessionStorage.getItem('loginUserIPDetails') || '{}');

  const createAuditLogData = (userEmail: string, userId: string, accountTypeLkpcd: string, eventLkpcdStatus: string, ipAddress: string) => ({
    userId: userEmail || '',
    userSid: userId || '',
    accountTypeLkpcd: accountTypeLkpcd || '',
    userIpv4Address: ipAddress || '',
    userIpv6Address: ipAddress || '',
    userMacAddress: loggedInUserIPDetails?.userMacAddress || null,
    userHostName: window?.location?.host || window?.location?.hostname || '',
    userRequestHeaderJson: null,
    eventLkpcd: 'LI',
    eventStatusLkpcd: eventLkpcdStatus,
    pageName: 'admin_dashboard',
    componentApiName: null,
    componentApiAttributesJson: null,
    errorJson: null,
    mctReportInstanceSid: null,
    mctReportActivitySid: null,
    mctReportSubactivitySid: null,
    capturedScreenFileName: null,
    capturedScreenFileLocation: null,
    createdBy: userEmail || '',
    createdDate: setDateInCST(new Date(), 'YYYY-MM-DDTHH:mm:ss'),
  });


  const fetchB2ccodes = async (authCode: any) => {

    const ipResponse = await ReportInventoryService.getUserIpDetails();
    try {
      setIsLoading(true);

      if (ipResponse) {
        const setUserIPDetails = {
          ipAddress: ipResponse.data.ipAddress,
          ipVersion: ipResponse.data.ipVersion,
        };

        sessionStorage.setItem('loginUserIPDetails', JSON.stringify(setUserIPDetails));
      }

      const response = await ReportInventoryService.getB2cAuthCode(authCode);
      if (response && response.data) {
        setB2cUserDetails(response.data.userDetails);
        // setB2cUserGroups(response.data.b2cGroupNames);
        console.log('response.data--- ', response.data);

        // Set the access token in session storage
        sessionStorage.setItem('msalToken', response.data.authToken);
        sessionStorage.setItem('signedInUserType', 'HealthPlanUser');
        sessionStorage.setItem('signedInUserId', response.data.userDetails.b2cEmail)
        sessionStorage.setItem('signedInB2CPlanId', response.data.isMcPlanUser)

        const userDetails = {
          userId: response.data.userDetails.b2cMemberId,
          userFirstName: response.data.userDetails.b2cGivenName,
          userLastName: response.data.userDetails.b2cFamilyName,
          userEmail: response.data.userDetails.b2cEmail,
          organizationUnitCode: response.data.userDetails.b2cExtensionOrganizationName,
          accountTypeLkpcd: response.data.userDetails.accountTypeLkpcd,
          mcoStaffCtgryLkpcd: response.data.userDetails.mcoStaffCtgryLkpcd,

        };

        sessionStorage.setItem('loginUserDetails', JSON.stringify(userDetails));

        // setUserDetails({
        //   // userDetails: response.data.userDetails,
        //   b2cUserGroups: response.data.b2cGroupNames,
        // });
        // const auditLogCreated = sessionStorage.getItem('auditLogCreated');
        // if (!auditLogCreated) {
        //   await ReportInventoryService.createAuditLog(createAuditLogData(response.data.userDetails.b2cEmail,
        //     response.data.userDetails.b2cMemberId, response.data.userDetails.accountTypeLkpcd, 'S', ipResponse.data.ipAddress));

        //   // Redirect to the home page or any other desired route
        //   sessionStorage.setItem('auditLogCreated', 'true');
        // }
        history.push('/');
      }
    } catch (error) {
      console.log('error', error);
      await ReportInventoryService.createAuditLog(createAuditLogData(loggedInUserDetailsForAudit?.userEmail, loggedInUserDetailsForAudit?.userId, loggedInUserDetailsForAudit?.accountTypeLkpcd, 'E', ipResponse.data.ipAddress));
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (b2bLoggedinUserCode && !sessionStorage.getItem('msalToken') && sessionStorage.getItem('signedInUserType') !== 'HealthPlanUser') {
      fetchB2ccodes(b2bLoggedinUserCode);
    }
  }, [b2bLoggedinUserCode]);

  const parseJWTToken = (token: string): any | null => {
    try {
      if (!token) {
        console.warn("No token provided");
        return null;
      }
      const parts = token.split('.');
      if (parts.length !== 3) {
        console.warn("Token does not have 3 parts:", token);
        return null;
      }
      let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      while (base64.length % 4 !== 0) {
        base64 += '=';
      }
      const jsonPayload = atob(base64);
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error("Error decoding JWT token", error, token);
      return null;
    }
  };

  const getB2CUserGroups = async (objectId: string): Promise<string[]> => {
    setIsLoading(true);

    try {
      console.log("Fetching groups for objectId:", objectId);
      setIsLoading(true);
      // const response = await axios.post(
      //   getB2CGroupUrl(),
      //   {
      //     objectId: objectId
      //   },
      //   {
      //     headers: {
      //       'Content-Type': 'application/json',
      //     }
      //   }
      // );

      const encodedObjectId = btoa(objectId);
      const response = await ReportInventoryService.getB2CUserGroupsApi(encodedObjectId);
      if (response.status === 200) {
        console.log("B2C Groups API response:", response.data);

        // Extract group names from the response
        const groupNames = response.data.groupNames || response.data.groups || [];
        return groupNames;
      }

      return [];
    } catch (error) {
      console.error("Error fetching user groups:", error);
      // Return empty array on error, or you could return parsed.groupNames as fallback
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  const fetchUserGroups = async () => {
    setIsLoading(true);
    const userListResponse = await ReportInventoryService.getAllMcUsers();

    if (accounts?.[0]?.username && (userType !== "HealthPlanUser")) {
      const ipResponse = await ReportInventoryService.getUserIpDetails()
      if (ipResponse) {
        const setUserIPDetails = {
          ipAddress: ipResponse.data.ipAddress,
          ipVersion: ipResponse.data.ipVersion,
        };

        sessionStorage.setItem('loginUserIPDetails', JSON.stringify(setUserIPDetails));
      }

      const loggedInUser = userListResponse?.data.find((user: any) => user?.email?.toLowerCase() === accounts[0]?.username?.toLowerCase());

      if (!loggedInUser) {
        toast.error(Error_Messages.User_Not_Setup_Or_Expired);
        setIsLoading(false);
        return;
      }

      const currentDate = new Date();
      const userStartDate = new Date(loggedInUser.startDate);
      const userEndDate = new Date(loggedInUser.endDate);

      if (!loggedInUser || loggedInUser.oprtnlFlag !== 'A') {
        // No active record for user
        // setUserAccessErrorMessage(Error_Messages.User_Not_Setup_Or_Expired);
        toast.error(Error_Messages.User_Not_Setup_Or_Expired);
        setIsLoading(false);
        return;
      }

      if (loggedInUser.oprtnlFlag !== 'A') {
        // No active record for user
        // setUserAccessErrorMessage(Error_Messages.User_Not_Setup_Or_Expired);
        toast.error(Error_Messages.User_Not_Setup_Or_Expired);
        setIsLoading(false);
        return;
      }

      if (currentDate < userStartDate || currentDate > userEndDate) {
        // No active record for user
        // setUserAccessErrorMessage(Error_Messages.User_Not_Setup_Or_Expired);
        toast.error(Error_Messages.User_Not_Setup_Or_Expired);
        setIsLoading(false);
        return;
      }

      if (loggedInUser.afStatusLkpcd !== 'A') {
        // Approval flow status is not Approved
        // setUserAccessErrorMessage(Error_Messages.User_Review_Or_Rejected);
        toast.error(Error_Messages.User_Review_Or_Rejected);
        setIsLoading(false);
        return;
      }

      if (loggedInUser.accountStatusLkpcd === 'L') {
        // Account is Locked
        // setUserAccessErrorMessage(Error_Messages.User_Account_Locked);
        toast.error(Error_Messages.User_Account_Locked);
        setIsLoading(false);
        return;
      }

      if (loggedInUser.accountStatusLkpcd !== 'A') {
        // Account is not Active (but not Locked)
        // setUserAccessErrorMessage(Error_Messages.User_Account_Inactive_Or_Terminated);
        toast.error(Error_Messages.User_Account_Inactive_Or_Terminated);
        setIsLoading(false);
        return;
      }

      console.log('loggedInUser--- ', loggedInUser)
      if (loggedInUser) {
        const userDetails = {
          userId: loggedInUser.userDetailsSid,
          userFirstName: loggedInUser.userFirstName,
          userLastName: loggedInUser.userLastName,
          userEmail: loggedInUser.userEmail,
          organizationUnitCode: loggedInUser.orgUnitCd,
          accountTypeLkpcd: loggedInUser.accountTypeLkpcd,
          mcoStaffCtgryLkpcd: loggedInUser.mcoStaffCtgryLkpcd,
        };
        sessionStorage.setItem('loginUserDetails', JSON.stringify(userDetails));

        setLoggedInUserDetails(userDetails);
      }

      const auditLogCreated = sessionStorage.getItem('auditLogCreated');
      if (!auditLogCreated) {
        await ReportInventoryService.createAuditLog(createAuditLogData(loggedInUser.userEmail, loggedInUser.userDetailsSid, loggedInUser.accountTypeLkpcd, 'S', ipResponse.data.ipAddress));
        sessionStorage.setItem('auditLogCreated', 'true');
      }
      try {
        const userGroupsFromDbResponse = await ReportInventoryService.getUserXUserGroupListByFilterDate(loggedInUser.userDetailsSid);

        if (userGroupsFromDbResponse) {

          const dbUserGroups = userGroupsFromDbResponse.data;
          console.log('User Groups from Table:', dbUserGroups);

          if (inProgress === "none") {

            const account = accounts[0];
            const tokenRequest = {
              scopes: ['User.Read', 'Group.Read.All'],
              account: account
            };
            const tokenResponse = await instance.acquireTokenSilent(tokenRequest);
            if (tokenResponse) {
              const accessToken = tokenResponse.accessToken;
              sessionStorage.setItem('msalToken', accessToken);

              const allGroupsFromAzure = await fetchAllMemberGroups('https://graph.microsoft.com/v1.0/me/memberOf', accessToken);

              const dbCodes = new Set((Array.isArray(dbUserGroups) ? dbUserGroups : []).map((g: any) => String(g.userGroupCode || '').toLowerCase().trim()));

              const dropdownOptions = (allGroupsFromAzure || [])
                .filter((group: any) => {
                  const display = String(group?.displayName || '');
                  const norm = display.toLowerCase().trim();
                  // include only if matches envPrefix (case-insensitive) AND exists in DB codes
                  return norm.includes((envPrefix || '').toLowerCase()) && dbCodes.has(norm);
                })
                .map((group: any) => {
                  const label = group.description || group.displayName;
                  return { value: String(group.displayName), label };
                });

              console.log('AD groups--- ', dropdownOptions)
              setSignedInUserGroupsList(dropdownOptions);

              if (dropdownOptions.length === 0) {
                setUserAccessErrorMessage(Error_Messages.No_permissions_found_for_this_user);
                toast.error(Error_Messages.No_permissions_found_for_this_user);
              } else {
                setUserAccessErrorMessage('');
              }
            }
          } else {
            console.error('MSAL instance is not initialized.');
          }
        } else {
          setUserAccessErrorMessage(Error_Messages.No_permissions_found_for_this_user);
          toast.error(Error_Messages.No_permissions_found_for_this_user);
        }
      } catch (error) {
        console.error('Error fetching user groups:', error);
        setUserAccessErrorMessage(Error_Messages.No_permissions_found_for_this_user);
        toast.error(Error_Messages.No_permissions_found_for_this_user);
      } finally {
        setIsLoading(false);
      }
    }
    else if (userType === "HealthPlanUser" && nonStateUserId) {
      try {
        const isB2CUserPlanId = sessionStorage.getItem('signedInB2CPlanId')
        const userNameId = sessionStorage.getItem('loginUserDetails');

        const ipResponse = await ReportInventoryService.getUserIpDetails()
        if (ipResponse) {
          const setUserIPDetails = {
            ipAddress: ipResponse.data.ipAddress,
            ipVersion: ipResponse.data.ipVersion,
          };

          sessionStorage.setItem('loginUserIPDetails', JSON.stringify(setUserIPDetails));
        }

        if (isB2CUserPlanId === 'PlanIdValid' && userNameId) {
          const parsedUserNameId = JSON.parse(userNameId);
          const loggedInUser = nonStateUserId ? userListResponse?.data.find((user: any) => (user?.userEmail?.toLowerCase() === nonStateUserId?.toLowerCase()) &&
            (user?.email?.toLowerCase() === parsedUserNameId?.userNameId.toLowerCase()) && (user?.accountTypeLkpcd === 'T')) : null;

          // const loggedInUser = nonStateUserId ? userListResponse.find(user:UserList) => user?.email?.toLowerCase() === nonStateUserId?.toLowerCase()) : null;

          if (!loggedInUser) {
            toast.error(Error_Messages.User_Not_Setup_Or_Expired);
            setIsLoading(false);
            return;
          }

          const currentDate = new Date();
          const userStartDate = new Date(loggedInUser.startDate);
          const userEndDate = new Date(loggedInUser.endDate);

          if (!loggedInUser || loggedInUser.oprtnlFlag !== 'A') {
            // No active record for user
            // setUserAccessErrorMessage(Error_Messages.User_Not_Setup_Or_Expired);
            toast.error(Error_Messages.User_Not_Setup_Or_Expired);
            setIsLoading(false);
            return;
          }

          if (loggedInUser.oprtnlFlag !== 'A') {
            // No active record for user
            // setUserAccessErrorMessage(Error_Messages.User_Not_Setup_Or_Expired);
            toast.error(Error_Messages.User_Not_Setup_Or_Expired);
            setIsLoading(false);
            return;
          }

          if (currentDate < userStartDate || currentDate > userEndDate) {
            // No active record for user
            // setUserAccessErrorMessage(Error_Messages.User_Not_Setup_Or_Expired);
            toast.error(Error_Messages.User_Not_Setup_Or_Expired);
            setIsLoading(false);
            return;
          }

          if (loggedInUser.afStatusLkpcd !== 'A') {
            // Approval flow status is not Approved
            // setUserAccessErrorMessage(Error_Messages.User_Review_Or_Rejected);
            toast.error(Error_Messages.User_Review_Or_Rejected);
            setIsLoading(false);
            return;
          }

          if (loggedInUser.accountStatusLkpcd === 'L') {
            // Account is Locked
            // setUserAccessErrorMessage(Error_Messages.User_Account_Locked);
            toast.error(Error_Messages.User_Account_Locked);
            setIsLoading(false);
            return;
          }

          if (loggedInUser.accountStatusLkpcd !== 'A') {
            // Account is not Active (but not Locked)
            // setUserAccessErrorMessage(Error_Messages.User_Account_Inactive_Or_Terminated);
            toast.error(Error_Messages.User_Account_Inactive_Or_Terminated);
            setIsLoading(false);
            return;
          }

          if (loggedInUser) {
            const setUserDetails = {
              userId: loggedInUser.userDetailsSid,
              userFirstName: loggedInUser.userFirstName,
              userLastName: loggedInUser.userLastName,
              userEmail: loggedInUser.userEmail,
              organizationUnitCode: loggedInUser.orgUnitCd,
              userNameId: loggedInUser.email,
              accountTypeLkpcd: loggedInUser.accountTypeLkpcd,
              mcoStaffCtgryLkpcd: loggedInUser.mcoStaffCtgryLkpcd,
            };

            sessionStorage.setItem('loginUserDetails', JSON.stringify(setUserDetails));
            setLoggedInUserDetails(setUserDetails);
          }

          const auditLogCreated = sessionStorage.getItem('auditLogCreated');
          if (!auditLogCreated) {
            await ReportInventoryService.createAuditLog(createAuditLogData(loggedInUser.userEmail,
              loggedInUser.userDetailsSid, loggedInUser.accountTypeLkpcd, 'S', ipResponse.data.ipAddress));

            // Redirect to the home page or any other desired route
            sessionStorage.setItem('auditLogCreated', 'true');
          }

          // if (!selectedProfile) {
          const authCode = sessionStorage.getItem('msalToken');
          if (authCode && authCode !== 'undefined' && authCode !== 'null') {
            const parsed = parseJWTToken(authCode);
            setIsLoading(true);
            getB2CUserGroups(parsed.sub)
              .then(async (groups) => {

                const b2cGroups = Array.isArray(groups) ? groups : [];

                // fetch DB-assigned groups for this user (API already filters by date)
                const userAssignmentsResp = await ReportInventoryService.getUserXUserGroupListByFilterDate(loggedInUser.userDetailsSid);
                const dbCodes = new Set(
                  (Array.isArray(userAssignmentsResp?.data) ? userAssignmentsResp.data : [])
                    .map((g: any) => String(g.userGroupCode || '').toLowerCase().trim())
                );

                const dropdownOptions = b2cGroups
                  .filter((group: string) => {
                    const norm = String(group || '').toLowerCase().trim();
                    return norm.includes((envPrefix || '').toLowerCase()) && dbCodes.has(norm);
                  })
                  .map((group: string) => ({
                    value: group,
                    label: `MCO ${group.split('-').pop() || group}`,
                  }));

                setB2cUserGroups(dropdownOptions);

                if (dropdownOptions.length === 1) {
                  const singleOption = dropdownOptions[0];
                  setSelectedGroup(singleOption.value);
                  sessionStorage.setItem('selectedProfile', singleOption.value);
                  sessionStorage.setItem('selectedProfileLabel', singleOption.label);
                  setSignedInUserGroupsList([]);
                } else if (dropdownOptions.length > 1) {
                  setSignedInUserGroupsList(dropdownOptions);
                } else {
                  toast.error(Error_Messages.No_permissions_found_Please_contact_NEDHHS_administartor);
                  setSignedInUserGroupsList([]);
                }
              })
              .finally(() => {
                setIsLoading(false);
              });
          }
          // }
        } else {
          console.log('No PlanIdValid')
          setSelectedGroup('');
          sessionStorage.removeItem('selectedProfile')
          sessionStorage.removeItem('selectedProfileLabel')
          // setUserAccessErrorMessage(Error_Messages.No_permissions_found_Please_contact_NEDHHS_administartor);
          toast.error(Error_Messages.No_permissions_found_Please_contact_NEDHHS_administartor);
        }
        // setLoggedInUserDetails(sessionStorage.getItem('loginUserDetails'));

      } catch (error) {
        console.error('Error fetching user groups:', error);
        setUserAccessErrorMessage(Error_Messages.No_permissions_found_Please_contact_NEDHHS_administartor);
        toast.error(Error_Messages.No_permissions_found_Please_contact_NEDHHS_administartor);
      } finally {
        setIsLoading(false);
      }
    }
    else if (mcUserGroupsList.length === 0 || !globalVariable) {
      setUserAccessErrorMessage(Error_Messages.No_permissions_found_for_this_user);
      toast.error(Error_Messages.No_permissions_found_for_this_user);
    }
  };


  useEffect(() => {
    sessionStorage.removeItem('savedFilters');
    sessionStorage.removeItem('ContractReportPageLimit')
  }, []);

  useEffect(() => {
    fetchUserGroups();
  }, [inProgress]);

  useEffect(() => {
    const fetchPermissions = async () => {
      if (selectedProfile && selectedProfile !== '' && selectedProfile !== null && selectedProfile !== '[]' && selectedProfile !== 'undefined') {
        try {
          const response = await ReportInventoryService.getAllUserGroupsFromDBByUserGroupId(selectedProfile);
          if (response) {
            setPermissionsFromApiResponse(response.data);
            setUserAccessErrorMessage('')
          } else {
            setUserAccessErrorMessage(Error_Messages.No_permissions_found_for_this_user);
            toast.error(Error_Messages.No_permissions_found_for_this_user);
          }
        } catch (error) {
          setUserAccessErrorMessage(Error_Messages.An_error_occurred_while_fetching_permissions);
          toast.error(Error_Messages.An_error_occurred_while_fetching_permissions);
        }
      }
    };

    fetchPermissions();
  }, [selectedProfile]);

  useEffect(() => {
    fetchOrganizationUnitsTableLookupData()
  }, []);

  // useEffect(() => {
  //   if (accounts?.[0]?.username && mcUsersList.length > 0 &&(userType !== "HealthPlanUser")) {
  //     const loggedInUser = mcUsersList.find(user => user?.email?.toLowerCase() === accounts[0]?.username?.toLowerCase());

  //     if (loggedInUser) {
  //       const userDetails = {
  //         userId: loggedInUser.userDetailsSid,
  //         userFirstName: loggedInUser.userFirstName,
  //         userLastName: loggedInUser.userLastName,
  //         userEmail: loggedInUser.userEmail,
  //         organizationUnitCode: loggedInUser.orgUnitCd,
  //       };
  //       sessionStorage.setItem('loginUserDetails', JSON.stringify(userDetails));
  //       setLoggedInUserDetails(userDetails);
  //     }
  //   } else {
  //     const nonStateUSerLogin = sessionStorage.getItem('signedInUserId');
  //     const loggedInUser = mcUsersList.find(user => user?.email?.toLowerCase() === nonStateUSerLogin?.toLowerCase());

  //     if (loggedInUser) {
  //       const userDetails = {
  //         userId: loggedInUser.userDetailsSid,
  //         userFirstName: loggedInUser.userFirstName,
  //         userLastName: loggedInUser.userLastName,
  //         userEmail: loggedInUser.userEmail,
  //         organizationUnitCode: loggedInUser.orgUnitCd,
  //       };

  //       sessionStorage.setItem('loginUserDetails', JSON.stringify(userDetails));
  //       setLoggedInUserDetails(userDetails);
  //     }
  //   }
  // }, [accounts, mcUsersList, nonStateUserId]);

  // useEffect(() => {
  //   ReportInventoryService.getAllUserGroupsFromDBByUserGroupId('DHHS_AR_NEMCIS_STT_TST-ADMIN')
  // }, []);

  const fetchAllMcUsersData = async () => {
    try {
      const response = await ReportInventoryService.getAllMcUsers();
      if (response) {
        setMcUsersList(response.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchAllMcUsersData();
  }, []);

  useEffect(() => {
    setIsLoading(true);
    const timeoutId = setTimeout(() => {
      if (userType === null && (!accounts?.[0]?.localAccountId)) {
        history.push('/sign-in');
      }
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [accounts, history, userType]);

  async function fetchAllMemberGroups(url: string, accessToken: string, groups: any[] = []): Promise<any[]> {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const data = await response.json();
    const newGroups = groups.concat(data.value);
    if (data['@odata.nextLink']) {
      return fetchAllMemberGroups(data['@odata.nextLink'], accessToken, newGroups);
    } else {
      return newGroups;
    }
  }

  const contractReportRouteFn = () => {
    history.push('/contact-report-inventory');
  };

  const uploadReportRouteFn = async () => {
    console.log("Attempting to navigate to /upload-reports");
    try {
      history.push('/upload-reports');
      console.log("Navigation to /upload-reports successful");
    } catch (error) {
      console.error("Failed to navigate to /upload-reports", error);
    }
  };

  const remindersRouteFn = async () => {
    history.push('/reminders-notifications');
  };

  const dashboardRouteFn = async () => {
    history.push('/main-dashboard');
  };
  const referenceRouteFn = async () => {
    history.push('/reference-data');
  };

  const userManagementRouteFn = async () => {
    history.push('/user-management');
  };

  const sftpUploadedRouteFn = async () => {
    //history.push('/sftp-uploaded-reports');
  };

  useEffect(() => {
    ReportInventoryService.getUserIpDetails()
      .then(res => {
        console.log('User IP:', res.data.ipAddress);
        console.log('IP Version:', res.data.ipVersion);

        if (res) {
          const setUserIPDetails = {
            ipAddress: res.data.ipAddress,
            ipVersion: res.data.ipVersion,
          };

          sessionStorage.setItem('loginUserIPDetails', JSON.stringify(setUserIPDetails));
        }
      })
      .catch(err => console.error(err));
  }, []);

  const handleGroupChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPermissionsFromApiResponse([]);
    sessionStorage.removeItem('selectedProfile');
    sessionStorage.removeItem('selectedProfileLabel');
    const selectedValue = e.target.value;
    setSelectedGroup(selectedValue);
    sessionStorage.setItem('selectedProfile', selectedValue);
    const selectedLabel = e.target.options[e.target.selectedIndex].text;

    if (selectedLabel !== 'Select Profile') {
      sessionStorage.setItem('selectedProfileLabel', selectedLabel);
    } else {
      sessionStorage.removeItem('selectedProfileLabel');
    }
  };

  const isNonStateUser = loggedInUserDetails?.organizationUnitCode === "NEDHHS";
  const homePageStyle = userAccessErrorMessage || !sessionStorage.getItem('selectedProfile') || checkAccess('admin_dashboard', 'NOAC') ? { pointerEvents: 'none', opacity: 0.5 } : {};
  const isAlertsAndNotificationsDisabled = checkAccess('reminders_alerts', ['VWNA', 'NOAC']);

  console.log("selectedProfile:", signedInUserGroupsList);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>

      {isLoading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading.....</p>
        </div>
      ) : (
        <React.Fragment>
          <div className="flex-grow">
            <Navbar />
            {showBannerFlag && (
              <div
                style={{
                  backgroundColor: systemUnavailableFlag ? '#d32f2f' : '#ffc843',
                  color: '#ffffff',
                  padding: '12px 20px',
                  textAlign: 'center',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                }}
              >
                <span style={{ fontSize: '24px' }}>⚠️</span>
                <span>{systemUnavailableBannerMessage}</span>
              </div>
            )}
            <div className="header-container">
              <div className="page-subtitle-container">
                <PageSubTitle text={'Welcome to Nebraska Managed Care Insight System (NEMCIS)'} />
              </div>
              {/* {isNonStateUser && ( */}

              <div>
                {signedInUserGroupsList.length === 0 ? (
                  <div style={{ color: 'red', whiteSpace: 'pre-line' }}>{userAccessErrorMessage}</div>
                ) : (

                  <div className="dropdown-container">
                    {/* {isNonStateUser && ( */}
                    <Dropdown
                      choices={signedInUserGroupsList}
                      emptyChoiceLabel="Select Profile"
                      name="reviewDecision"
                      label="Select Profile"
                      data-testid="profile_group"
                      value={selectedProfile}
                      onChange={handleGroupChange}
                      mandatoryLabel={true}
                    />
                    {/* )} */}
                  </div>
                )}
              </div>
              {/* )} */}

            </div>

            <div className="home_page_css" style={{ display: 'flex', justifyContent: 'center', ...homePageStyle, pointerEvents: homePageStyle.pointerEvents as React.CSSProperties['pointerEvents'] }}>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: {
                    xs: 'repeat(1, 1fr)',
                    sm: 'repeat(2, 1fr)',
                    md: 'repeat(3, 1fr)',
                  },
                  gap: 3,
                  justifyContent: 'center',

                  '& > :not(style)': {
                    m: 1,
                    width: { xs: '100%', sm: 260 },
                    height: { xs: 'auto', sm: 175 },
                    maxWidth: 260,
                    maxHeight: 175,
                    transition: 'box-shadow 0.2s ease-in-out',
                    '&:hover': {
                      boxShadow: '0 0 20px rgba(0, 123, 255, 0.5)',
                    },
                  },
                  my: 0,
                  m: 0,
                }}
              >
                {/* Contract Report Inventory */}
                <div
                  onClick={contractReportRouteFn}
                  className={`border-[7px] border-[#bac6de] cursor-pointer text-primary md:text-lg text-md md:font-medium font-normal rounded-3xl md:py-5 py-2 px-2 w-80 flex flex-row items-start justify-between`}
                >
                  <img src={reports} alt="lock" width='100px' className="self-start" />

                  <div className="space-y-2 mb-16 flex flex-col justify-between ml-2">
                    <p className="leading-5 mb-3 text-black">Report Inventory</p>
                    <div className="flex gap-2">
                      <p className="text-xs">Track the scheduled and submitted reports</p>
                    </div>
                  </div>
                </div>

                {/* Upload Reports and Data */}
                {userType && (
                  <>
                    <div
                      onClick={uploadReportRouteFn}
                      className={`border-[7px] border-[#bac6de] cursor-pointer text-primary md:text-lg text-md md:font-medium font-normal rounded-3xl md:py-5 py-2 px-2 w-80 flex flex-row items-start justify-between`}
                      style={!checkAccess('upload_submit_reports', 'NOAC') ? {} : { pointerEvents: 'none', opacity: 0.5 }}
                    >
                      <img src={uploadIcon} alt="lock" width='100px' className="self-start" />

                      <div className="space-y-2 mb-16 flex flex-col justify-between ml-2">
                        <p className="leading-5 mb-3 text-black">Upload Reports and Data</p>
                        <div className="flex gap-2">
                          <p className="text-xs">Upload your required report or
                            data via the secure portal</p>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* Reminders and Notifications */}
                <div
                  // style={isAlertsAndNotificationsDisabled ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                  onClick={remindersRouteFn}
                  className={`border-[7px] border-[#bac6de] cursor-pointer text-primary md:text-lg text-md md:font-medium font-normal rounded-3xl md:py-5 py-2 px-2 w-80 flex flex-row items-start justify-between`}
                >
                  <img src={calendarIcon} alt="lock" width='100px' className="self-start" />

                  <div className="space-y-2 mb-16 flex flex-col justify-between ml-2 ml-2">
                    <p className="leading-5 mb-3 text-black">Alerts and Notifications</p>
                    <div className="flex gap-2">
                      <p className="text-xs">Alerts and Notifications for user actions</p>
                    </div>
                  </div>
                </div>

                {/* Dashboard */}
                {accounts?.[0]?.localAccountId && (
                  <>
                    <div
                      // onClick={dashboardRouteFn}
                      className={`border-[7px] border-[#bac6de] cursor-pointer text-primary md:text-lg text-md md:font-medium font-normal rounded-3xl md:py-5 py-2 px-2 w-80 flex flex-row items-start justify-between`}
                    >
                      <img src={dashboardIcon} alt="lock" width='100px' className="self-start" />

                      <div className="space-y-2 mb-16 flex flex-col justify-between ml-2">
                        <p className="leading-5 mb-3 text-black">Dashboard</p>
                        {/* <p className="leading-5 mb-3 text-black">Reporting and Analytics</p> */}
                        <div className="flex gap-2">
                          {/* <p className="text-xs">Plan Performance excellence scores, Reviewers Groups performance, and other reports</p> */}
                          <p className="text-xs">Compare Overall Plan Compliance Performance</p>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* Reference */}
                <div
                  onClick={referenceRouteFn}
                  className={`border-[7px] border-[#bac6de] cursor-pointer text-primary md:text-lg text-md md:font-medium font-normal rounded-3xl md:py-5 py-2 px-2 w-80 flex flex-row items-start justify-between`}
                >
                  <img src={referenceIcon} alt="lock" width='100px' className="self-start" />

                  <div className="space-y-2 mb-16 flex flex-col justify-between ml-2">
                    <p className="leading-5 mb-3 text-black">Report Master Catalog</p>
                    <div className="flex gap-2">
                      <p className="text-xs"> Click here to access the required reports, associated templates and submission requirements</p>
                    </div>
                  </div>
                </div>

                {/* User Management */}
                {accounts?.[0]?.localAccountId && (
                  <>
                    <div
                      onClick={userManagementRouteFn}
                      className={`border-[7px] border-[#bac6de] cursor-pointer text-primary md:text-lg text-md md:font-medium font-normal rounded-3xl md:py-5 py-2 px-2 w-80 flex flex-row items-start justify-between`}
                    >
                      <img src={userManagementIcon} alt="lock" width='100px' className="self-start" />

                      <div className="space-y-2 mb-16 flex flex-col justify-between ml-2">
                        <p className="leading-5 mb-3 text-black">User Inventory</p>
                        <div className="flex gap-2">
                          <p className="text-xs">Managing Users and their access
                            priveleges</p>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* SFTP Reports */}
                {accounts?.[0]?.localAccountId && (
                  <>
                    <div
                      onClick={sftpUploadedRouteFn}
                      className={`border-[7px] border-[#bac6de] cursor-pointer text-primary md:text-lg text-md md:font-medium font-normal rounded-3xl md:py-5 py-2 px-2 w-80 flex flex-row items-start justify-between`}
                    >
                      <img src={uploadIcon} alt="lock" width='100px' className="self-start" />

                      <div className="space-y-2 mb-16 flex flex-col justify-between ml-2 ml-2">
                        <p className="leading-5 mb-3 text-black">Manage SFTP Reports</p>
                        <div className="flex gap-2">
                          <p className="text-xs">Link/Unlink the submitted SFTP reports</p>
                        </div>
                      </div>
                    </div>
                  </>
                )}

              </Box>

            </div>
          </div>
          <div style={{ marginTop: 'auto' }}>
            <Footer />
          </div>
        </React.Fragment>
      )}
    </div>
  )
}
